import { render } from "./englishHeroTitle.vue?vue&type=template&id=4898cd66&scoped=true"
import script from "./englishHeroTitle.vue?vue&type=script&lang=js"
export * from "./englishHeroTitle.vue?vue&type=script&lang=js"

import "./englishHeroTitle.vue?vue&type=style&index=0&id=4898cd66&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4898cd66"]])

export default __exports__